import { render, staticRenderFns } from "./AreaRow.vue?vue&type=template&id=38e46a42&"
import script from "@/components/area-row/AreaRow.ts?vue&type=script&lang=ts&"
export * from "@/components/area-row/AreaRow.ts?vue&type=script&lang=ts&"
import style0 from "./area-row.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports